// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3cbwP","label":"CategoryService_label__BOKUA","location":"CategoryService_location__3eynh"};